import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=a8189780&scoped=true"
import script from "./OrderStatus.vue?vue&type=script&lang=ts"
export * from "./OrderStatus.vue?vue&type=script&lang=ts"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&id=a8189780&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8189780",
  null
  
)

export default component.exports